import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AsyncPipe, DatePipe } from '@angular/common';
import { DoctorService } from '../../services/doctor.service';
import { AnalyticsService } from '../../services/analytics.service';
import { TableModule } from 'primeng/table';
import { KpiCardComponent } from './kpi-card/kpi-card.component';
import { EmergencyAlertsService } from '../../services/emergency-alerts.service';
import { map, Observable } from 'rxjs';
import { EmergencyAlerts } from '../../interfaces/emergency-alerts';
import { KpiCardI } from '../../interfaces/config';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ButtonModule, AsyncPipe, TableModule, KpiCardComponent, DatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  totalEmergencyAlerts: number = 0;

  timePeriod = 3;
  topN = 5;
  activePeriod = signal(3);

  private doctorService = inject(DoctorService);

  private analyticsService = inject(AnalyticsService);
  private emergencyAlertService = inject(EmergencyAlertsService);

  doctors$ = this.doctorService.getDoctors().pipe(
    map((doctors) => {
      return doctors.length;
    })
  );
  countries$ = this.analyticsService.getCountries$();
  cities$ = this.analyticsService.getCities$();
  alertCount$ = this.analyticsService.getAlertCount$(this.countries$);
  messageCount$ = this.analyticsService.getMessageCount$();

  alerts = signal<EmergencyAlerts[]>([]);

  kpiCardConfig: KpiCardI[] = [
    {
      header: 'Επαφές',
      data: this.doctors$,
      entity: 'Ιατροί',
      iconBackgroundColor: 'bg-green-100',
      icon: 'pi pi-user-plus',
      iconColor: 'text-green-500',
      route: '/manage-network',
      routeLabel: 'Διαχείριση Δικτύου',
    },
    {
      header: 'Μηνύματα',
      data: this.messageCount$,
      entity: 'Μηνύματα',
      iconBackgroundColor: 'bg-orange-100',
      icon: 'pi pi-inbox',
      iconColor: 'text-orange-500',
      route: '/chat',
      routeLabel: 'Συνομιλίες',
    },
    {
      header: 'Επείγουσες Ειδοποιήσεις',
      data: this.alertCount$,
      entity: 'Επείγουσες Ειδοποιήσεις',
      iconBackgroundColor: 'bg-red-100',
      icon: 'pi pi-heart',
      iconColor: 'text-red-500',
      route: '/emergency-alerts',
      routeLabel: 'Επείγουσες Ειδοποιήσεις',
    },
  ];

  constructor() {
    effect(
      () => {
        const allAlerts = this.emergencyAlertService.alerts();
        const recentAlerts = allAlerts.slice(0, 5);
        this.alerts.set(recentAlerts);
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {}
  getAlertCount(alerts: any) {
    let count = 0;
    if (alerts) {
      alerts.map((alert: any) => {
        count += Number(alert.count);
      });
    }

    return count;
  }

  changePeriod(period: number): void {
    this.activePeriod.set(period);
    this.analyticsService.setActivePeriod(period);
  }

  getSeverity(period: number): any {
    return this.activePeriod() === period ? 'primary' : 'secondary';
  }
}
